export default __webpack_public_path__ + "img/ZLhBDaZK.a648138d.svg";